'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');

var BreadcrumbView = Marionette.ItemView.extend({
    template: require('components/common/templates/breadcrumbs'),

    callbackMapping: {},

    events: {
        'click a.js-action': 'actionClicked',
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: ['#js-action-menu'],

            getDeviceID: function (view) {
                return view.id;
            },
        },
    },

    initialize: function (data) {
        this.data = data;
        this.firstRender = true;
        // device = parent device? => no sibling -> do not show a dropdown menu
        this.noSiblings = data.device.get('wired_to') === data.device.id;

        // get connecting device
        var connectingDeviceID = this.data.device.get('wired_to');
        this.connectingDevice = AppState.getDeviceInfo(connectingDeviceID);
        // nothing found? -> ask the backend
        if ($.isEmptyObject(this.connectingDevice)) {
            this.connectingDevice = undefined;
            var self = this;
            $.when(App.request('device:model', connectingDeviceID)).done(function (device) {
                if (device) {
                    self.connectingDevice = device.attributes;
                }
                self.render();
            });
        }
    },

    setPermission: function (permissions) {
        var ro = this.options.readOnlyRight;
        if (ro && permissions.get(ro)) {
            this.data.read_only = true;
        }
    },

    getIdxText: function (idx) {
        return idx !== undefined ? '' + (idx + 1) : '';
    },

    serializeData: function () {
        var self = this;

        if (this.data.action_label) {
            this.data.actions = this.data.actions || [];
            this.data.actions.push({
                action_label: this.data.action_label,
                name: 'default',
                action: this.data.action_cb,
                read_only: this.data.read_only,
            });
        }

        var mapCallback = function (a) {
            var key = 'js-action' + a.idx;
            self.callbackMapping[key] = a.action;
        };

        // assign idx to actions and map callbacks
        _.each(this.data.actions, function (a, idx) {
            a.idx = self.getIdxText(idx);
            mapCallback(a);

            // filter menu items -> remove inactive entries
            a.menu_items = _.filter(a.menu_items || [], function (sub) {
                return sub.show_me === true;
            });

            // assign idx to remaining entries
            _.each(a.menu_items, function (sub, idx_sub) {
                sub.idx = a.idx + '_' + self.getIdxText(idx_sub);
                mapCallback(sub);
            });
        });

        // get connecting device link (parent device which is connected to the server)
        if (this.connectingDevice) {
            var parentCategory = _.invert(Consts.Category)[this.connectingDevice.category];
            // user is allowed to see the parent device (=parentCategory is set)?
            if (parentCategory && parentCategory != 'Virtual') {
                this.data.parentIcon = Consts.CategoryData[parentCategory].icon;
                this.data.parentLink = [
                    Consts.CategoryData[parentCategory].url,
                    this.connectingDevice.id,
                    'admin-devices',
                ].join('/');
            }
        }
        // device locked? -> show locked state
        this.data.locked = AppState.showLockIcon(this.id);
        this.data.noSiblings = this.noSiblings;
        this.data.device = this.getOption('device');
        return this.data;
    },

    onShow: function () {
        if (!this.noSiblings) {
            var self = this;
            Misc.initDevicePicker({
                onClick: function () {},
                styleClass: 'breadcrumb-dropdown',
                hideIfEmpty: '#js-siblings-dropdown',
                filter: function () {
                    return {
                        capabilities: [Consts.RouteToCapability[self.data.target.link]],
                        parent: self.getOption('device').get('parent'),
                        limit: 70,
                    };
                },
                filterResult: function (devices) {
                    // no siblings found? -> re-render and get rid of the dropdown
                    if (!devices || devices.length === 0) {
                        self.noSiblings = true;
                        self.render();
                        return;
                    }
                    var result = [];
                    // todo: when filtering for capabilities is implemented in the backend, get rid of the filtering
                    // and only inject the link
                    // filter devices by capabilities and inject the link destination
                    _.each(devices, function (sibling) {
                        if (Misc.canAccessRoute(self.data.target.link, sibling.capabilities)) {
                            var categoryData = Consts.DeviceCategory[sibling.category];
                            sibling.link = categoryData.url + '/' + sibling.id + '/' + self.data.target.link;
                            sibling.locked = AppState.showLockIcon(sibling.id);
                            result.push(sibling);
                        }
                    });
                    // only have the device itself? -> do not show a drop down
                    if (result.length === 1 && result[0].id == self.getOption('device').id) {
                        // hide dropdown and show only the device
                        self.noSiblings = true;
                        self.render();
                        return [];
                    }
                    return result;
                },
            });
        }
    },

    actionClicked: function (e) {
        e.preventDefault();

        if (this.data.read_only) return;

        // call action callback
        var f = this.callbackMapping[e.currentTarget.id] || function () {};
        f(this);
    },
});

module.exports = BreadcrumbView;
